import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chart: {
      width: theme.spacing(5),
      display: 'flex',
      justifyContent: 'space-around',
      transform: 'rotate(150deg)',
    },

    circleBg: {
      fill: 'none',
      stroke: '#E1E8ED',
      strokeWidth: 3.8,
    },

    circle: {
      fill: 'none',
      strokeWidth: theme.spacing(0.5),
      strokeLinecap: 'round',
    },

    stroke: {
      stroke: '#6EDCCF',
    },
  }),
);

export default useStyles;
